import * as React from 'react';
import { resolve } from "inversify-react";
import autobind from "autobind-decorator";

import { ToastNotifications } from 'src/core/ui/toast';
import { ObjectUtils } from 'src/core/utils/object';
import { ControllerProps } from 'src/router';
import { DialogService } from "src/core/services/ui/dialog.service";
import { LanguageListView } from "./language-list.view";
import { LanguageListDataService } from "src/core/ui/language/language.data";

export class LanguageListController extends React.Component<ControllerProps<any>, any> {

    protected dataService: LanguageListDataService;

    @resolve
    protected dialogService: DialogService;

    @resolve
    protected toast: ToastNotifications;

    public constructor(props) {
        super(props);
        this.dataService = LanguageListDataService.make();
    }

    public componentDidMount() {
        this.loadData();
    }

    @autobind
    protected onItemDoubleClicked(item: LanguageSummary) {
        this.props.history.push(`/general/language/${item == null ? 'new' : item.languageCode}`);
    }

    @autobind
    protected loadData() {
        this.props.setBusy(true);
        this.dataService.addSorting('languageCode', 'asc', true);
        this.dataService.load(query => query)
            .then(() => this.props.setBusy(false))
            .catch(error => {
                this.props.setBusy(false)
                this.toast.showToast('Request failed', ObjectUtils.parseError(error), 'error');
            });
    }

    public render() {
        if (this.dataService == null) return null;
        return <LanguageListView
            model={this.dataService}
            setBusy={this.props.setBusy} onItemDoubleClicked={this.onItemDoubleClicked} {...this.props } />
    }
}



// WEBPACK FOOTER //
// ./src/app/general/language/list/language-list.controller.tsx